export const BASE_CLASS = 'mt-ModelDetail'
export const HERO_CLASS = `${BASE_CLASS}-hero`
export const TABS_CLASS = `${BASE_CLASS}-tabs`
export const PARAGRAPH_CLASS = `${BASE_CLASS}Paragraph`
export const LOW_DASH = '_'
export const DASH = '-'
export const DEFAULT_OFFSET = 0
export const BASIC_VERSION_INDEX = 0
export const DEFAULT_COUNT = 10
export const REPRESENTATION_TYPE = {
  NUMERIC: 'numeric',
  LONG_STRING: 'long'
}
export const SPACE_STRING = ' '
const today = new Date()
const currentMonth = today.getMonth()
export const LAST_DAY_OF_MONTH = new Date(today.getFullYear(), currentMonth + 1, 0)
export const SCROLL_PARAMS = {block: 'center', behavior: 'smooth'}
export const collapsibleMinHeight = 84
